import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { ConsoleLogExporter } from './exporters/console-exporter';
import { MultiTargetLogRecordProcessor } from './processor/multi-target-processor';
import { init } from './provider';
export const initLogging = (serviceName, config) => {
    const logExporters = {
        console: new ConsoleLogExporter(),
        otlp: new OTLPLogExporter({
            url: config.url,
        }),
    };
    const logProcessor = new MultiTargetLogRecordProcessor({
        exporters: logExporters,
        exporterTargets: config.severityMap,
        flushConfig: config.flushConfig,
    });
    init(serviceName, logProcessor);
};
export { getLogger } from './provider';
//# sourceMappingURL=index.js.map